// @flow

import operator from 'fc-operator-asset/src/operator'

// Operator
export default operator

// Redux
export { default as initialState } from 'fc-operator-asset/src/initialState'
export { default as reducers } from 'fc-operator-asset/src/reducers'

// Sagas
export { default as watchOperations } from './sagas/operations'
